import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { postAPICall } from '../utils/axios.util'
// import { nextAPIRoutes } from '../constants/apiRoutes'
import { handleSnackBar } from "./global";
import MESSAGES from "../constants/messages";
import bookingService from "../services/booking.service";

export const getPersonalRentalList = createAsyncThunk(
  "personalRental/fetch",
  async (
    {
      requestType,
      type,
      page,
      search,
    }: { requestType: number; page: number; type: number; search: string },
    { dispatch, getState }
  ) => {
    try {
      // const reducer: any = getState();
      dispatch(setLoadingList(true));
      const resp: any = await bookingService.fetch({
        body: {
          page_no: page,
          filter: type,
          request_type: requestType,
          search,
        },
      });
      dispatch(setLoadingList(false));
      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(setLoadingList(false));

      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const getPeronalRentalBookingDetails = createAsyncThunk(
  "booking/details",
  async ({ id }: { id: number }, { dispatch }) => {
    try {
      const resp: any = await bookingService.fetchDetails({
        body: {
          id,
        },
      });
      console.log(resp);
      return resp?.data?.data ?? [];
    } catch (e: any) {
      dispatch(setLoadingList(false));

      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);
const personalRentalSlice = createSlice({
  name: "personalRental",
  initialState: {
    page: 1,
    type: 1,
    loadingList: false,
    list: [],
    listMeta: {},

    details: {},
  },
  reducers: {
    setPage: (state, { payload }) => {
      state.page = payload;
    },
    setType: (state, { payload }) => {
      state.type = payload;
    },
    setLoadingList: (state, { payload }) => {
      state.loadingList = payload;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getPersonalRentalList.fulfilled, (state, { payload }) => {
        state.list = payload?.list ?? [];
        state.listMeta = payload?.meta ?? [];
      })
      .addCase(
        getPeronalRentalBookingDetails.fulfilled,
        (state, { payload }) => {
          state.details = payload ?? {};
        }
      ),
});

export default personalRentalSlice.reducer;
export const { setType, setLoadingList, setPage } = personalRentalSlice.actions;
